import React from "react";
import "./About.css";

const differentiators = [
  {
    title: "Arquitetura resiliente",
    description:
      "Projetos que combinam performance, alta disponibilidade e segurança para sustentar operações críticas.",
  },
  {
    title: "Relacionamento próximo",
    description:
      "Trabalhamos lado a lado com cada cliente, atuando como extensão estratégica das equipes internas.",
  },
  {
    title: "Entrega ponta a ponta",
    description:
      "Consultoria, implantação e suporte contínuo com especialistas certificados em múltiplas tecnologias.",
  },
];

const pillars = [
  "Infraestrutura de redes e conectividade",
  "Sistemas de CFTV e controle de acesso",
  "Administração de servidores e nuvem",
  "Soluções de software e automação",
];

function About() {
  return (
    <section className="about page-section" id="about">
      <div className="section-container">
        <div className="section-header">
          <span className="section-overline">Quem somos</span>
          <h2 className="section-title">Mais de duas décadas construindo tecnologia confiável</h2>
          <p className="section-description">
            A The Union Technology nasceu da visão de três amigos com mais de vinte anos de experiência combinada.
            Unimos expertise técnica, visão estratégica e atendimento consultivo para entregar soluções completas de
            tecnologia que impulsionam negócios exigentes.
          </p>
        </div>

        <div className="about__grid">
          <article className="about__story surface-card">
            <p>
              Nossa atuação engloba infraestrutura de redes, sistemas de CFTV, controle de acesso, desenvolvimento e
              administração de ambientes corporativos. Cada projeto começa entendendo o contexto do cliente para criar
              implementações sob medida, escaláveis e com governança.
            </p>
            <p>
              Buscamos sempre exceder expectativas, oferecendo suporte proativo, planos de contingência e políticas de
              segurança alinhadas às melhores práticas do mercado. Acreditamos no relacionamento interpessoal como
              diferencial para construir parcerias duradouras e resultados consistentes.
            </p>
            <ul className="about__pillars">
              {pillars.map((pillar) => (
                <li key={pillar}>{pillar}</li>
              ))}
            </ul>
          </article>

          <div className="about__side">
            <div className="about__metrics">
              <div className="stat-card">
                <span className="stat-card__value">+20</span>
                <span className="stat-card__label">anos de trajetória</span>
              </div>
              <div className="stat-card">
                <span className="stat-card__value">+250</span>
                <span className="stat-card__label">projetos entregues</span>
              </div>
              <div className="stat-card">
                <span className="stat-card__value">24/7</span>
                <span className="stat-card__label">monitoramento inteligente</span>
              </div>
            </div>

            <div className="about__differentiators">
              {differentiators.map(({ title, description }) => (
                <div className="about__card" key={title}>
                  <h3>{title}</h3>
                  <p>{description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
